import React, { useState } from "react";
import BonusHistoryFilters from "./BonusHistoryFilters";
import MobileFilters from "components/user/MobileFilters";

const BonusHistory = () => {
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [isMobileFiltersOpen, setIsMobileFiltersOpen] = useState(false);

  const handleFilters = (data) => {
    setIsMobileFiltersOpen(false);
    setSelectedFilters(data);
  };
  return (
    <div className="h-screen max-h-[calc(100vh-260px)] overflow-y-auto">
      <div className="bg-white/15 p-3 md:block hidden">
        <BonusHistoryFilters
          setSelectedFilters={setSelectedFilters}
          handleFilters={handleFilters}
        />
      </div>
      <MobileFilters
        onClickToggle={() => setIsMobileFiltersOpen(!isMobileFiltersOpen)}
        isOpen={isMobileFiltersOpen}
        selectedFilters={selectedFilters}
      >
        <BonusHistoryFilters
          setSelectedFilters={setSelectedFilters}
          handleFilters={handleFilters}
        />
      </MobileFilters>
      <div className="py-10 text-center text-white/70 text-[12px]">
        No bets to show
      </div>
    </div>
  );
};

export default BonusHistory;
